import { useState } from "react";
import Hero from "../components/home/Hero";
import Testimonials from "../components/home/Testimonials";
import CourseFinder from "../components/home/CourseFinder";
import ScholarshipSpotlights from "../components/home/ScholarshipSpotlights";
import {
  WhyUs, ServicesSection, DestinationsPreview, JourneySection,
  UniversitiesPreview, TestPrepPreview, WhatWeDo, OSSDHighlight,
} from "../components/home/HomeSections";

export default function Home() {
  const [heroQuery, setHeroQuery] = useState(null);

  const onHeroSearch = (payload) => {
    setHeroQuery(payload);
    setTimeout(() => document.getElementById("course-finder")?.scrollIntoView({ behavior: "smooth", block: "start" }), 60);
  };

  return (
    <>
      <Hero onSearch={onHeroSearch} />
      <CourseFinder externalQuery={heroQuery} />
      <WhyUs />
      <WhatWeDo />
      <ServicesSection />
      <DestinationsPreview />
      <OSSDHighlight />
      <JourneySection />
      <UniversitiesPreview />
      <ScholarshipSpotlights />
      <TestPrepPreview />
      <Testimonials />
    </>
  );
}
